import { Controller, useFormContext, useWatch } from "react-hook-form";

import { DraftField } from "@/components/cadastro/draft-field";
import { FormSection } from "@/components/ui/form-section";
import { TriStateField } from "@/components/cadastro/tri-state-field";
import type { CadastroDraft } from "@/lib/cadastro-draft";
import { CadastroLabels } from "@/lib/labels";

export function ClinicSection() {
	const { control, setValue } = useFormContext<CadastroDraft>();
	const hasInsurance = useWatch({ control, name: "has_insurance" });

	return (
		<FormSection title={CadastroLabels.sectionTitle.clinic}>
			<div className="col-span-2">
				<Controller
					control={control}
					name="has_insurance"
					render={({ field }) => (
						<TriStateField
							label={CadastroLabels.insurance_presence}
							value={field.value}
							onChange={(value) => {
								field.onChange(value);

								if (value === false) {
									setValue("insurance", "", { shouldDirty: true });
								}
							}}
							slot="has-insurance"
						/>
					)}
				/>
			</div>

			<div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
				<DraftField fieldKey="insurance" disabled={hasInsurance === false} />
				<DraftField fieldKey="occupation" />
				<DraftField fieldKey="how_found" />
				<DraftField fieldKey="how_found_detail" />
				<DraftField fieldKey="referred_by" span />
			</div>
		</FormSection>
	);
}
